import { useMemo, useState, useEffect } from 'react'
import { numberFormat, round } from "shared/util"

import { BukaStaticticsRecord } from "./data"

import { ListRecordWithBar } from 'components/controls/listRecordWithBar'

import {
  Stack, Box, BoxProps, Typography, Alert, List, Button
} from "@mui/material"

import { SisetuDoctorsConditions } from '../condition'

const INITIAL_SHOW_COUNT = 9

type BukaListSectionProps = {
  sisetuCode: string
  dataList?: BukaStaticticsRecord[]
  condition: SisetuDoctorsConditions
  onChangeCondition: (axis: 'buka', condition: { code: string, name: string }) => void
} & BoxProps
export const BukaListSection = ({
  sisetuCode,
  dataList,
  condition,
  onChangeCondition,
  ...others
}: BukaListSectionProps) => {
  const [showAll, setShowAll] = useState<boolean>(false)

  const summary = useMemo<{
    list: BukaStaticticsRecord[]
    total: number
    max: number
  } | null>(() => {
    if (!dataList) return null

    const newDataList = dataList
    newDataList.sort((a, b) => b.kojinCount - a.kojinCount)

    let total = 0
    let max = 0
    for(const record of newDataList) {
      total += record.kojinCount
      max = Math.max(record.kojinCount, max)
    }
    return {
      list: newDataList,
      total: total,
      max: max
    }
  }, [dataList])

  useEffect(() => setShowAll(false), [sisetuCode])

  return (
    <Box {...others} sx={{ height: '100%' }}>
      <Stack direction="column" sx={{ height: '100%' }}>
        <Stack direction="row" alignItems="center" paddingX={1} paddingY={1} spacing={0.5}>
          <Typography variant="body1" component="div" color="text.primary" sx={{ textAlign: 'left', flexGrow: 1 }}>所属部課</Typography>
          { summary ? <Typography variant="body2" component="div" color="text.secondary" sx={{ textAlign: 'right' }}>
            全 {numberFormat(summary.list.length)} 科目 / 有効 {numberFormat(round(summary.total, 1))} 人
          </Typography> : <></> }
        </Stack>
        
        { summary ? (
          <Stack
            direction="column"
            spacing={1}
            sx={{
              flexGrow: 1,
              overflow: 'auto'
            }}
          >
            { summary.list.length > 0 ? (
              <List disablePadding>
                { (showAll ? summary.list : summary.list.slice(0, INITIAL_SHOW_COUNT)).map((r, i) => (
                  <ListRecordWithBar
                    key={`buka_${r.bukaCode}`}
                    index={i}
                    selected={condition.buka?.code === r.bukaCode}
                    code={r.bukaCode}
                    name={r.bukaName}
                    count={r.kojinCount}
                    max={summary.max}
                    onClicked={(code, name) => onChangeCondition('buka', { code, name })}
                  />
                )) }
                { !showAll && summary.list.length > INITIAL_SHOW_COUNT && <Button fullWidth onClick={() => setShowAll(true)}>すべて表示</Button> }
              </List>
            ) : (
              <Box padding={1}><Alert severity="info">対象が見つかりません.</Alert></Box>
            ) }
          </Stack>
        ) : <></> }
      </Stack>
    </Box>
  )
}